<div class="mobile-menu-wrapper">
	<ea-button-link (onClick)="handleToggle()" name="yourAccountDropdown">
		Your Account
		<ea-toggle-link
			textWhenToggled=""
			textWhenUntoggled=""
			[isToggled]="isProfileActionsToggled"
			name="toggleProfileActions"
		>
		</ea-toggle-link>
	</ea-button-link>

	<ea-collapsible-panel [visible]="isProfileActionsToggled">
		<ul>
			@if (isAdmin) {
				<li>
					<ea-button-link
						(onClick)="navigateToChangePassword()"
						name="changePasswordLink"
						buttonRole="link"
						class="navigation-menu-items"
						>Change Password
					</ea-button-link>
				</li>
			}
			<li>
				<ea-button-link
					(onClick)="navigateToProfile()"
					name="profileLink"
					buttonRole="link"
					class="navigation-menu-items"
					>Profile
				</ea-button-link>
			</li>
			<li>
				<ea-logout></ea-logout>
			</li>
		</ul>
	</ea-collapsible-panel>
</div>
